import React from 'react';

const PlusThin = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="490"
    height="490"
    viewBox="0 0 18 18">
    <path d="M9.671 0L9.671 8.329 18 8.329 18 9.671 9.671 9.671 9.671 18 8.329 18 8.329 9.671 0 9.671 0 8.329 8.329 8.329 8.329 0z" transform="translate(-1257 -747) translate(435 726) translate(822 21)"/>
  </svg>
);

export default PlusThin;
